<template>
	<div id="gongys">
		<div class="fflex ffbet">
			<ul class="fflex headBox">
				<li @click="jump('shanglei')">商品类型</li>
				<li class="active">供应商</li>
				<li @click="jump('shangx')">商品信息</li>
				<li @click="jump('wuliu')">物流设置</li>
				<li @click="jump('churukl')">出入库类型</li>
				<li @click="jump('rizhi')">日志列表</li>
			</ul>
			<div class="sousuok">
				<el-input size="mini" placeholder="供应商查询" v-model="gyshang"  @keyup.enter.native="searchname" style="border: 1px solid gainsboro;">

					<i class="el-icon-search el-input__icon" slot="suffix" v-on:click="searchname">
					</i>
				</el-input>
			</div>
		</div>

		<div class="fflex ffend" style="margin-top: 5px;margin-bottom: 10px">

			<el-button type="success" round size="mini" class="purBtnsz" @click="tan(1)">添加供应商</el-button>

		</div>

		<div class="tableBox">
			<table class="table table-bordered">
				<thead>
					<tr>
						<th>序号</th>
						<th>供应商编号</th>
						<th>供应商名称</th>
						<th>供货商电话</th>
						<th>联系人</th>
						<th>联系人手机</th>
						<th>建档时间</th>
						<th>操作</th>


					</tr>
				</thead>
				<tbody>
					<tr v-for="(ta,taindex) in tabledata" :key="taindex">
						<td>{{taindex+1}}</td>
						<td>
							{{ta.supplier_num}}
						</td>
						<td>{{ta.supplier_name}}</td>
						<td>{{ta.tel}}</td>
						<td>{{ta.linkman}}</td>
						<td>{{ta.tel}}</td>

						<td>{{ta.create_time}}</td>

						<td>
							<span class="tablebtnBox">
								<div class="qianziBtn-mini" style="    background: rgb(0, 204, 228);color: #fff" @click="tan(2,ta.id)">查看</div>

								<div class="shenziBtn-mini" @click="tan(3,ta.id)">修改</div>
								<div class="qianziBtn-mini" @click="delfn(ta.id)" style="    background: rgb(255, 121, 124);color: #fff">删除</div>
							</span>
						</td>

					</tr>

				</tbody>
			</table>
			<p>共有4条记录 当前1页/共1页</p>

		</div>

		<div class="table-bottom">
			<div>
				<el-pagination @current-change="handleCurrentChange" :current-page="currentpage" :page-size="pageone" background
				 layout="prev, pager, next" :total="total">
				</el-pagination>
			</div>
		</div>

		<el-dialog class="tanchuang" :title="Ttitle" :visible.sync="gongyst" width="650px">

			<div>
				<el-row>
					<el-col :span="12" class="marBo2">
						<div class="demo-input-suffix">
							<span class="inputT" style="color: red"><span>*</span>商家编号：</span>
							<el-input style="width: 200px" placeholder="自动生成" :disabled="true" size="small" v-model="tandate.supplier_num">
							</el-input>

						</div>

					</el-col>
					<el-col :span="12" class="marBo2">
						<span class="inputT" style="color: red"><span>*</span>商家名称：</span>
						<el-input style="width: 200px" placeholder="商品名称" :disabled="dis" size="small" v-model="tandate.supplier_name">
						</el-input>
					</el-col>
					<el-col :span="12" class="marBo2">
						<span class="inputT">商家电话：</span>
						<el-input style="width: 200px" placeholder="格式：xxxx-xxxxxxxx" :disabled="dis" size="small" v-model="tandate.tel">
						</el-input>
					</el-col>
					<el-col :span="12" class="marBo2">
						<span class="inputT">联 系 人：</span>
						<el-input style="width: 200px" v-model="tandate.linkman" :disabled="dis" size="small">
						</el-input>
					</el-col>

					<el-col :span="12" class="marBo2">
						<span class="inputT">手机号码：</span>
						<el-input style="width: 200px" v-model="tandate.phone" :disabled="dis" size="small">
						</el-input>
					</el-col>

					<el-col :span="12" class="marBo2">
						<span class="inputT">联系人Email：</span>
						<el-input style="width: 200px" v-model="tandate.email" :disabled="dis" size="small">
						</el-input>
					</el-col>

					<el-col :span="12" class="marBo2">
						<span class="inputT">开户名称：</span>
						<el-input style="width: 200px" v-model="tandate.accountname" :disabled="dis" size="small">
						</el-input>
					</el-col>


					<el-col :span="12" class="marBo2">
						<span class="inputT">开户行：</span>
						<el-input style="width: 200px" v-model="tandate.bankname" :disabled="dis" size="small">
						</el-input>
					</el-col>

					<el-col :span="12" class="marBo2">
						<span class="inputT">银行账号：</span>
						<el-input style="width: 200px" v-model="tandate.enterpriseaccount" :disabled="dis" size="small">
						</el-input>
					</el-col>

					<el-col :span="12" class="marBo2">
						<span class="inputT">单位地址：</span>
						<el-input style="width: 200px" v-model="tandate.address" :disabled="dis" size="small">
						</el-input>
					</el-col>

					<el-col :span="12" class="marBo2">
						<span class="inputT">单位邮编：</span>
						<el-input style="width: 200px" v-model="tandate.zipcode" :disabled="dis" size="small">
						</el-input>
					</el-col>

					<el-col :span="24" class="marBo2">
						<span class="inputT" style="padding-bottom: 10px"> 备注：</span>
						<el-input :disabled="dis" type="textarea" :autosize="{ minRows: 2}" v-model="tandate.notes">
						</el-input>
					</el-col>
					<el-col :span="24" v-if="zhuang==3" style="text-align: center">
						<el-button type="success" round size="mini" class="purBtnsz" @click="querxiu(tandate.id)">确认修改
						</el-button>
					</el-col>

					<el-col :span="24" v-if="zhuang==1" style="text-align: center">
						<el-button type="success" round size="mini" class="purBtnsz" @click="tianj">确认添加</el-button>
					</el-col>

				</el-row>
			</div>
		</el-dialog>


	</div>
</template>

<script>
	export default {
		data() {
			return {
				token: '',
				gyshang: '',
				currentpage: 1,
				pageone: 10,
				total: 0,
				gongyst: false,
				zhuang: '',
				Ttitle: '',
				dis: false,
				shangphone: '',
				tandate: {},
				tabledata: '',

			};
		},
		methods: {
			querxiu: function(id) {
				let self = this;
				self.$confirm('是否要进行修改?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {

					$.ajax({
						type: 'POST',
						url: process.env.apiUrl + 'saas/JxcSupplier/update',
						dataType: 'json',
						data: {
							id: id,
							token: self.token,
							supplier_name: self.tandate.supplier_name,
							tel: self.tandate.tel,
							linkman: self.tandate.linkman,
							phone: self.tandate.phone,
							email: self.tandate.email,
							accountname: self.tandate.accountname,
							bankname: self.tandate.bankname,
							enterpriseaccount: self.tandate.enterpriseaccount,
							address: self.tandate.address,
							zipcode: self.tandate.zipcode,
							notes: self.tandate.notes
						},
						success: function(data) {

							if (data.status == 2) {
								self.$message({
									type: 'error',
									message: data.msg
								});
							} else {
								self.$message({
									type: 'success',
									message: data.msg
								});
								self.gongyst = false;
								self.gonggong()

							}

						}
					})

				}).catch(() => {
					self.gongyst = false
				});
			},
			tan: function(e, id) {
				let self = this;
				self.zhuang = e;
				if (self.zhuang == 1) {
					self.Ttitle = '添加供应商'
					self.dis = false;
					// self.tandate.supplier_num = '',
					// 	self.tandate.supplier_name = '',
					// 	self.tandate.tel = '',
					// 	self.tandate.linkman = '',
					// 	self.tandate.phone = '',
					// 	self.tandate.email = '',
					// 	self.tandate.accountname = '',
					// 	self.tandate.bankname = '',
					// 	self.tandate.enterpriseaccount = '',
					// 	self.tandate.address = '',
					// 	self.tandate.zipcode = '',
					// 	self.tandate.notes = ''

                    self.$set(self.tandate, 'supplier_num', '' )
                    self.$set(self.tandate, 'supplier_name', '' )
                    self.$set(self.tandate, 'tel', '' )
                    self.$set(self.tandate, 'linkman', '' )
                    self.$set(self.tandate, 'phone', '' )
                    self.$set(self.tandate, 'email', '' )
                    self.$set(self.tandate, 'accountname', '' )
                    self.$set(self.tandate, 'bankname', '' )
                    self.$set(self.tandate, 'enterpriseaccount', '' )
                    self.$set(self.tandate, 'address', '' )
                    self.$set(self.tandate, 'zipcode', '' )
                    self.$set(self.tandate, 'notes', '' )

				} else if (self.zhuang == 2) {
					self.Ttitle = '查看供应商'
					self.dis = true;

					$.ajax({
						type: 'POST',
						url: process.env.apiUrl + 'saas/JxcSupplier/edit',
						dataType: 'json',
						data: {
							id: id,
							token: self.token
						},
						success: function(data) {

							if (data.status == 1) {
								self.tandate = data.data;
							} else {
								self.tandate = ''
							}

						}
					})

				} else {
					self.Ttitle = '修改供应商'
					self.dis = false;
					$.ajax({
						type: 'POST',
						url: process.env.apiUrl + 'saas/JxcSupplier/edit',
						dataType: 'json',
						data: {
							id: id,
							token: self.token
						},
						success: function(data) {

							if (data.status == 1) {
								self.tandate = data.data;
							} else {
								self.tandate = ''
							}

						}
					})


				}
				self.gongyst = true;
			},
			handleCurrentChange: function(i) {

				let self = this;
				self.currentpage = i;
				self.gonggong()
			},
			searchname: function() {
				let self = this;
				self.page = 1
				self.gonggong()
			},
			delfn: function(id) {
				let self = this;
				this.$confirm('是否删除这个供应商?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					$.ajax({
						type: 'POST',
						url: process.env.apiUrl + 'saas/JxcSupplier/delete',
						dataType: 'json',
						data: {
							id: id,
							token: self.token
						},
						success: function(data) {
							if (data.status == 1) {
								self.$message({
									type: 'success',
									message: data.msg
								});

								self.gonggong()

							} else {
								self.$message({
									type: 'error',
									message: data.msg
								});
							}


						}
					})


				}).catch(() => {
					//                this.$message({
					//                    type: 'info',
					//                    message: '已取消删除'
					//                });
				});
			},
			jump: function(e) {
				this.$router.push({
					'name': e
				})
			},
			tianj: function() {
				let self = this;

				self.$confirm('是否确认添加供应商?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {

					$.ajax({
						type: 'POST',
						url: process.env.apiUrl + 'saas/JxcSupplier/store',
						dataType: 'json',
						data: {
							token: self.token,
							supplier_name: self.tandate.supplier_name,
							tel: self.tandate.tel,
							linkman: self.tandate.linkman,
							phone: self.tandate.phone,
							email: self.tandate.email,
							accountname: self.tandate.accountname,
							bankname: self.tandate.bankname,
							enterpriseaccount: self.tandate.enterpriseaccount,
							address: self.tandate.address,
							zipcode: self.tandate.zipcode,
							notes: self.tandate.notes
						},
						success: function(data) {
							if (data.status == 2) {
								self.$message({
									type: 'error',
									message: data.msg
								});
							} else {
								self.$message({
									type: 'success',
									message: data.msg
								});
								self.gongyst = false
								self.gonggong()
							}
						}
					})

				}).catch(() => {
					self.gongyst = false
				});


			},
			gonggong: function() {
				let self = this;
				$.ajax({
					type: 'POST',
					url: process.env.apiUrl + 'saas/JxcSupplier/index',
					dataType: 'json',
					data: {
						page: self.currentpage,
						pageone: self.pageone,
						token: self.token,
						search: self.gyshang
					},
					success: function(data) {
						if (data.status == 1) {
							self.tabledata = data.data;
							self.total = Number(data.map.count)
						} else {
							self.tabledata = '';
							self.total = 0
						}

					}
				})

			}


		},
		mounted: function() {

			var self = this;
			self.token = $.cookie('token');

			$.ajax({
				type: 'POST',
				url: process.env.apiUrl + 'saas/JxcSupplier/index',
				dataType: 'json',
				data: {
					page: 1,
					pageone: self.pageone,
					token: self.token
				},
				success: function(data) {

					if (data.status == 1) {
						self.tabledata = data.data;
						self.total = Number(data.map.count)
					} else {
						self.tabledata = '';
						self.total = 0
					}

				}
			})


		}


	}
</script>

<style scoped>
	ul {
		list-style: none;
	}

	#gongys p,
	label,
	ul {
		margin: 0;
		padding: 0;
	}

	.fflex {
		display: flex;
		display: -webkit-flex;
	}

	.ffbet {
		justify-content: space-between;
	}

	.ffend {
		justify-content: flex-end;
	}

	#gongys * {
		box-sizing: border-box;
	}

	#gongys {
		box-sizing: border-box;
		padding: 10px;
	}

	.headBox li {
		width: 75px;
		background: #8CBB77;
		height: 30px;
		line-height: 30px;
		margin-right: 8px;
		border-radius: 5px 5px 0 0;
		text-align: center;
		color: #fff;

	}

	.headBox li.active {
		background: #ecebfd;
		color: #8CBB77;
		box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .2);
	}

	.purBtnsz {
		background: #8CBB77 !important;
		height: 26px;
		border: none !important;
	}

	.marBo2 {
		margin-bottom: 10px;
	}

	.inputT {
		display: inline-block;
		width: 100px;

	}
</style>
<style>


</style>



// WEBPACK FOOTER //
// src/pages/jinxc/gongys.vue